import { DataTable, FlexBox, Icon, Page, Text } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { useMount } from 'react-use';

import { AppLink } from 'components/appLink';
import { withAutomations } from 'hocs';
import { useAppPathParams } from 'utils/url/useAppPathParams';

export const SettingsAutomationsAuditLogView = withAutomations(
  ({ automations: { item, getItem, getItemAsyncStatus } }) => {
    const { automationId } = useAppPathParams(
      '/settings/automations/flow/:automationId/history',
    );

    useMount(() => {
      getItem(automationId);
    });

    return (
      <Page>
        <Page.Head
          title={
            <FlexBox gap="200" alignItems="center">
              <AppLink
                path="/settings/automations"
                style={{ color: 'inherit' }}
              >
                <Text.Heading>Automations</Text.Heading>
              </AppLink>

              <Icon name="angle-right" />

              {item?.name}
            </FlexBox>
          }
        />

        <Page.Body>
          <Page.Section title="Audit log">
            <DataTable
              columns={[
                {
                  label: 'Edit',
                  selector: ({ updated_by }) => updated_by,
                  style: {
                    width: '70%',
                  },
                },
                {
                  label: 'Date',
                  selector: ({ updated_at }) => {
                    const time = moment(updated_at);
                    const localeData = moment.localeData();

                    return time.format(
                      `DD MMMM YYYY, ${localeData.longDateFormat('LT')}`,
                    );
                  },
                },
              ]}
              data={item?.updated_by_history ?? []}
              tableStatusProps={{
                loading: getItemAsyncStatus === 'loading',
                loadingFailed: getItemAsyncStatus === 'failed',
                emptyState:
                  getItemAsyncStatus === 'succeeded' &&
                  item?.updated_by_history?.length === 0
                    ? {
                        title: 'No data available',
                        description: '',
                      }
                    : undefined,
              }}
            />
          </Page.Section>
        </Page.Body>
      </Page>
    );
  },
);
